import { ref } from "vue";
import { defineStore } from "pinia";
import type { Remessa } from "@/entities/Remessa";

export const useRemessasStore = defineStore(
    "remessas-folha-24", () => {
    
        const remessa = ref<Remessa>();
        const remessas = ref<Remessa[]>([]);

        function getRemessas() {
            return remessas.value;
        }

        function setRemessas(rs: Remessa[]) {
            remessas.value = rs;
        }

        function deleteRemessas() {
            remessas.value = [];
        }

        function getRemessaSelecionada() {
            return remessa.value;
        }

        function setRemessaSelecionada (r: Remessa) {
            remessa.value = r;
        }

        function deleteRemessaSelecionada() {
            remessa.value = undefined;
        }

        return { remessa, remessas, getRemessas, setRemessas, getRemessaSelecionada, setRemessaSelecionada, deleteRemessas, deleteRemessaSelecionada };
    }
);
